var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
let MenuPartDifficulty = class MenuPartDifficulty extends React.PureComponent {
    render() {
        const { question } = this.props;
        return (React.createElement("div", { style: {
                marginTop: 10,
                maxWidth: 200,
                flex: '0 1 auto',
                marginLeft: 10,
                marginRight: 10
            } },
            React.createElement("div", { style: { fontSize: 12, fontWeight: 'bold', color: '#555', marginBottom: 5, marginLeft: 2 } }, "Diese Frage"),
            React.createElement("div", { onDoubleClick: () => alert(question.id), style: {
                    marginLeft: 2,
                    border: '1px solid #999',
                    borderRadius: 3,
                    width: '90%',
                    height: 15,
                    background: 'linear-gradient(to right, #a5c956 0%, #ffbf47 50%, #da4949 100%)'
                } },
                React.createElement("div", { style: {
                        height: 13,
                        backgroundColor: '#F6F6F6',
                        float: 'right',
                        width: `${100 * question.questionInfo.average}%`
                    } })),
            React.createElement("div", { style: { marginTop: 3, fontSize: '10.5px', textAlign: 'left' }, className: "text-muted" }, "Schwierigkeitsgrad")));
    }
};
MenuPartDifficulty = __decorate([
    observer
], MenuPartDifficulty);
export { MenuPartDifficulty };
